const sendRefEmailStatuses = {
  INITIAL: 'INITIAL',
  SEND_EMAIL: 'SEND_EMAIL',
  PREPARE_EMAIL: 'PREPARE_EMAIL',
  EMAIL_SENT: 'EMAIL_SENT',
};

module.exports = sendRefEmailStatuses;
